module.exports = __webpack_public_path__ + "media/images/photo/Agriculture/Agriculture-02-8cd5fb5dabd8d84a9e015d1bca4f3e2b.png";